import React from 'react'

const CheckOut = () => {
    return (
        <div className="h-screen flex items-center justify-center">
            <h1 className="text-2xl text-center font-bold">Developer will Build This is page. </h1>
        </div>
    )
}

export default CheckOut
